import { PropsWithChildren, useEffect, useState } from 'react';

import { FlexBox, FlexBoxProps } from '@blockworks/ui/flex-box';
import { cn } from '@blockworks/ui/system';

const TooltipContainer = ({ children, className, ...rest }: PropsWithChildren<FlexBoxProps>) => {
    const [ready, setReady] = useState(false);
    useEffect(() => {
        setReady(true);
    }, [setReady]);
    return (
        <FlexBox
            col
            minW="max"
            w={200}
            p={3}
            px={4}
            borderRadius="md"
            bgColor="base"
            color="base"
            border={1}
            className={cn(className, { 'opacity-0': !ready })}
            {...rest}
        >
            {children}
        </FlexBox>
    );
};

export { TooltipContainer };
